import { VStack as e } from "../Primitives/Stack.mjs";
import { Skeleton as t } from "../Primitives/Skeleton.mjs";
import { Page as n } from "./Page.mjs";
import { Grid as r } from "../Primitives/Grid.mjs";
import "react";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
//#region src/components/Page/PageSkeleton.tsx
var o = ({ blocks: o = 4 }) => /* @__PURE__ */ i(n, { children: /* @__PURE__ */ a(e, {
	gap: 3,
	children: [/* @__PURE__ */ a(e, {
		gap: 1.5,
		children: [/* @__PURE__ */ i(t, {
			width: 280,
			height: 32,
			radius: "md"
		}), /* @__PURE__ */ i(t, {
			width: 180,
			height: 16,
			radius: "md"
		})]
	}), /* @__PURE__ */ i(r, {
		columns: "1fr 1fr",
		gap: 3,
		responsive: { 1024: { columns: 1 } },
		children: Array.from({ length: o }).map((e, n) => /* @__PURE__ */ i(t, {
			height: 180,
			radius: "lg"
		}, n))
	})]
}) });
//#endregion
export { o as PageSkeleton };
